if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // CD CODE custom option
      if($('.custom_options_content .single_item-val input:checked').attr('data-custom_html') != undefined){
        var feild_1 = $('.custom-option-properties input.check_valid#Bust');
        var feild_2 = $('.custom-option-properties input.check_valid#Waist');
        var feild_3 = $('.custom-option-properties input.check_valid#Hips');
        var feild_4 = $('.custom-option-properties input.check_valid#Hollow-To-Floor');
        var feild_5 = $('.custom-option-properties input.check_valid#Height-Bare-Foot');
        var check_input = false;
  
        feild_1.css('border-color', 'initial');
        feild_2.css('border-color', 'initial');
        feild_3.css('border-color', 'initial');
        feild_4.css('border-color', 'initial');
        feild_5.css('border-color', 'initial');
        
        if(feild_1.val().trim() == ''){
          feild_1.css('border-color', 'red');
          check_input = true;
        }
        if(feild_2.val().trim() == ''){
          feild_2.css('border-color', 'red');
          check_input = true;
        }
        if(feild_3.val().trim() == ''){
          feild_3.css('border-color', 'red');
          check_input = true;
        }
        if(feild_4.val().trim() == ''){
          feild_4.css('border-color', 'red');
          check_input = true;
        }
        if(feild_5.val().trim() == ''){
          feild_5.css('border-color', 'red');
          check_input = true;
        }
  
        if(check_input == true){
          $('html, body').animate({
            scrollTop: $(".single_custom-size").offset().top - 133
          }, 50);
          return false;
        }
      }
      
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          // CD CODE
          if($('#production_time').val() == '2 weeks + $29'){
            var upsell_product = $('#production_time').attr('data-product-id');
             var upsell_arr = new FormData();
              var upsell_item = []
              upsell_item.push({
                  id: upsell_product, 
                  quantity: $('.quantity__input').val()
              });
              var upsell_formData = {
               'items': upsell_item
              }
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(upsell_formData)
              })
              .then(response => {
                window.location = window.routes.cart_url;
                return response.json();
              })
              .catch((error) => {
                console.error('Error:', error);
                window.location = window.routes.cart_url;
              });
          }else{
            window.location = window.routes.cart_url;
          }
          
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          // const quickAddModal = this.closest('quick-add-modal');
          // if (quickAddModal) {
          //   document.body.addEventListener('modalClosed', () => {
          //     setTimeout(() => { this.cart.renderContents(response) });
          //   }, { once: true });
          //   quickAddModal.hide(true);
          // } else {
          //   this.cart.renderContents(response);
          // }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
